/**
 * Minimal SVG sparkline — no axes, no tooltips, just the line.
 * Used in dashboard HLHeroActive (equity curve) and PaperRow.
 */
export function Sparkline({ data = [], width = 120, height = 40, color = '#22d3ee', negative = false, fill = true }) {
  if (!data || data.length < 2) {
    return (
      <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} className="opacity-20">
        <line x1={0} y1={height / 2} x2={width} y2={height / 2} stroke="currentColor" strokeWidth={1} strokeDasharray="4 4" />
      </svg>
    );
  }

  const lineColor = negative ? '#f87171' : color;
  const values = data.map(d => (typeof d === 'number' ? d : d.value ?? d.equity ?? 0));
  const min = Math.min(...values);
  const max = Math.max(...values);
  const range = max - min || 1;
  const pad = 2;

  const points = values.map((v, i) => {
    const x = pad + (i / (values.length - 1)) * (width - pad * 2);
    const y = pad + (1 - (v - min) / range) * (height - pad * 2);
    return `${x},${y}`;
  });

  const polyline = points.join(' ');
  const fillId = `sparkline-fill-${Math.random().toString(36).slice(2, 8)}`;

  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} preserveAspectRatio="none">
      {fill && (
        <>
          <defs>
            <linearGradient id={fillId} x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor={lineColor} stopOpacity={0.25} />
              <stop offset="100%" stopColor={lineColor} stopOpacity={0} />
            </linearGradient>
          </defs>
          <polygon
            points={`${pad},${height} ${polyline} ${width - pad},${height}`}
            fill={`url(#${fillId})`}
          />
        </>
      )}
      <polyline
        points={polyline}
        fill="none"
        stroke={lineColor}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
